import { useReactiveVar } from '@apollo/client'
import {
  comparisonVersionCalculatorVar,
  comparisonVersionVar,
  projectVar,
} from '../apollo/reactive-vars'
import { useCalculator } from './use-calculator'

type Hook = {
  updateComparisonCalculation: () => void
}

export function useComparisonCalculator(): Hook {
  const project = useReactiveVar(projectVar)
  const comparisonVersion = useReactiveVar(comparisonVersionVar)
  const { getCalculatedEnergies } = useCalculator()

  return {
    updateComparisonCalculation: () => {
      const calculator = getCalculatedEnergies(project, comparisonVersion)
      comparisonVersionCalculatorVar(calculator)
    },
  }
}
